import styled from "styled-components";
// import { Link as LinkR } from "react-router-dom";
// import { Link as LinkS } from "react-scroll";
// import { HashLink as LinkH } from "react-router-hash-link";

export const Wrapper = styled.div`
  border-radius: 20px;
  overflow: hidden;
`;

export const TextareaFormatted = styled.textarea`
  margin-bottom: 20px;
  font-size: 2ch;
  padding: 10px;
  width: 400px;
  resize: vertical;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.color3};
  border: 1px solid
    ${({ valid, theme }) => (valid ? theme.color2 : theme.color1)};
  color: ${({ theme }) => theme.color4};
  @media screen and (max-width: 576px) {
    width: 300px;
  }
  :focus {
    outline: none;
    border: 2px solid
      ${({ valid, theme }) => (valid ? theme.color2 : theme.color1)};
  }
  ::-webkit-scrollbar {
    width: 5px;
    /* outline:20px; */
  }
  ::-webkit-scrollbar-thumb {
    /* width: 50px; */
    background-color: ${({ valid, theme }) =>
      valid ? theme.color2 : theme.color1};
    border-radius: 20px;
  }
  ::-webkit-scrollbar-corner {
    display: none;
  }
`;
